"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * {@docCategory DocumentCard}
 */
var DocumentCardType;
(function (DocumentCardType) {
    /**
     * Standard DocumentCard.
     */
    DocumentCardType[DocumentCardType["normal"] = 0] = "normal";
    /**
     * Compact layout. Displays the preview beside the details, rather than above.
     */
    DocumentCardType[DocumentCardType["compact"] = 1] = "compact";
})(DocumentCardType = exports.DocumentCardType || (exports.DocumentCardType = {}));
//# sourceMappingURL=DocumentCard.types.js.map


//////////////////
// WEBPACK FOOTER
// ./~/office-ui-fabric-react/lib-commonjs/components/DocumentCard/DocumentCard.types.js
// module id = 943
// module chunks = 0